import * as React from "react"
import { Flex, Text, Box } from "@chakra-ui/react"
import { ProductPriceProps } from "./types"
import { QuantitySelector } from "./quantity-selector"
import { ProductAmount } from "./product-amount"
import { useRecoilValue } from "recoil"
import { brandingSelector } from "../../../../recoil/atoms/room"
import { productOverlaySelector } from "../../../../recoil/atoms/product-overlay"

const _ProductPrice: React.FC<ProductPriceProps> = ({
  selectedQuantity,
  setSelectedQuantity,
  selectedVariant,
  isSmallScreen,
  isProductWithoutOptions,
  productPriceContainerRef,
  isNoSpaceForPrice,
  isHiddenClone,
  noDisplay
}) => {
  const roomStyles = useRecoilValue(brandingSelector)
  const { currencySymbol, variants } = useRecoilValue(productOverlaySelector)

  const ProductAmoutProps = React.useMemo(() => {
    return {
      isSmallMainScreen: false,
      isBigBadge: false,
      isTransperent: false,
      currencySymbol,
      price: selectedVariant?.price,
      oldPrice: selectedVariant?.compare_at_price,
      quantity: selectedQuantity
    }
  }, [
    currencySymbol,
    selectedQuantity,
    selectedVariant?.compare_at_price,
    selectedVariant?.price
  ])

  const [containerWidth, setContainerWidth] = React.useState(0)

  React.useEffect(() => {
    const handleResize = () => {
      const width = document.getElementById("product-price").clientWidth
      setContainerWidth(width)
    }

    window.addEventListener("resize", handleResize)
    handleResize() // Вызываем функцию при монтировании компонента

    return () => {
      window.removeEventListener("resize", handleResize) // Очищаем слушатель при размонтировании компонента
    }
  }, [])

  const handleElementResize = element => {
    if (element.offsetLeft + element.offsetWidth > containerWidth) {
      element.classList.add("with-margin")
    } else {
      element.classList.remove("with-margin")
    }
  }

  React.useEffect(() => {
    const elements = Array.from(document.querySelectorAll(".element"))

    elements.forEach(element => {
      handleElementResize(element)
    })
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [containerWidth])

  return (
    <Flex
      display={noDisplay ? "none" : "flex"}
      id={noDisplay ? "nodisplay-product-price" : "product-price"}
      visibility={isHiddenClone ? "hidden" : "visible"}
      flexDirection={
        isSmallScreen || isProductWithoutOptions ? "column" : "row"
      }
      alignItems={isProductWithoutOptions ? "unset" : "center"}
      flexWrap={"wrap"}
      width={isHiddenClone && "max-content"}
      ref={productPriceContainerRef}
    >
      <Flex
        className="element"
        marginLeft={!isSmallScreen && "1px"}
        flexDirection={
          isSmallScreen || isProductWithoutOptions || isNoSpaceForPrice
            ? "column"
            : "row"
        }
        alignItems={
          isProductWithoutOptions || (isNoSpaceForPrice && !isHiddenClone)
            ? "unset"
            : "center"
        }
        /* marginBottom="0.5rem" */
        marginRight={!isSmallScreen && !isProductWithoutOptions && "2rem"}
      >
        {variants.length !== 0 && (
          <>
            <Text
              opacity={0.75}
              fontSize={"0.7rem"}
              marginRight={
                (!isSmallScreen ||
                  (isSmallScreen && isProductWithoutOptions)) &&
                "0.5rem"
              }
              color={roomStyles?.badgeTextColor && roomStyles?.badgeTextColor}
              fontFamily={
                roomStyles?.badgeFontFamily ?? "Assistant, sans-serif"
              }
            >
              {"Quantity"}
            </Text>
            <Box>
              <QuantitySelector
                value={selectedQuantity}
                onChange={setSelectedQuantity}
                isSmallMainScreen={true}
              />
            </Box>
          </>
        )}
      </Flex>
      <Flex
        className="element"
        alignItems={isNoSpaceForPrice && !isHiddenClone ? "unset" : "center"}
        marginLeft={!isSmallScreen && !isProductWithoutOptions && "0rem"}
        height={isNoSpaceForPrice && !isHiddenClone && "fit-content"}
        marginTop={isNoSpaceForPrice && !isHiddenClone && "auto"}
        marginBottom={isNoSpaceForPrice && !isHiddenClone && "4px"}
        width={isHiddenClone && "max-content"}
      >
        <ProductAmount {...ProductAmoutProps} />
      </Flex>
    </Flex>
  )
}

export const ProductPrice = React.memo(_ProductPrice)
